import { Injectable } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  baseUrl = environment.baseUrl;
  viewCompanyData: null;
  company_form: FormGroup = new FormGroup({
    id: new FormControl(null),
    company_name: new FormControl('',Validators.required),
    company_heading: new FormControl('', [Validators.required]),
    company_type: new FormControl('', [Validators.required]),
    phone: new FormControl('', [Validators.required]),
    mobile: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required]),
    website_url: new FormControl(''),
  });


  constructor(private http:HttpClient,) { 

  }

  populateForm(rowData: any){
    //this.company_form.setValue(rowData);
    this.company_form.setValue(_.omit(rowData, 'address','country', 'state', 'city', 'post_code',
      'user_id',  'created_at', 'updated_at'));
  }

  populate_our_company_form() {
    return this.http.get(this.baseUrl + '/get_our_company').subscribe(data=>{
      console.log(data);
      this.populateForm(data['data']);
    });
  }

  get_companies() {
    return this.http.get(this.baseUrl + '/get_companies');  
  }

  insert_company_details(formData: any)
  { 
    return this.http.post(this.baseUrl + '/create_company',{
      company_name : formData.company_name, 
      company_heading : formData.company_heading,
      company_type : formData.company_type,
      phone : formData.phone,
      mobile : formData.mobile,
      email : formData.email,
      website_url : formData.website_url,
    });
  }

  update_company_details(formData: any)
  { 
    return this.http.post(this.baseUrl + '/update_company',{
      id : formData.id,
      company_name : formData.company_name, 
      company_heading : formData.company_heading,
      company_type : formData.company_type,
      phone : formData.phone,
      mobile : formData.mobile,
      email : formData.email,
      website_url : formData.website_url,
    });
  }

  delete_company_details(rowid)
  { 
    return this.http.post(this.baseUrl + '/delete_company',{
      id : rowid,
    });
  }


  

}
